import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "mb-8 html-editor-wrapper" }
const _hoisted_2 = { class: "d-flex align-items-center fs-6 fw-bold mb-2" }
const _hoisted_3 = { class: "quill-editor-tournament" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_QuillEditor = _resolveComponent("QuillEditor")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("label", _hoisted_2, [
      _createElementVNode("span", {
        class: _normalizeClass({ required: _ctx.input.required })
      }, _toDisplayString(_ctx.input.label), 3)
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_QuillEditor, {
        content: _ctx.modelValue || '',
        "content-type": "html",
        options: _ctx.editorOptions,
        "onUpdate:content": _ctx.onChange,
        theme: "snow"
      }, null, 8, ["content", "options", "onUpdate:content"])
    ]),
    _createVNode(_component_ErrorMessage, {
      name: _ctx.input.name,
      class: "text-danger mt-2"
    }, null, 8, ["name"])
  ]))
}